// extracted by mini-css-extract-plugin
module.exports = {"root":"q3tQj","searchWrapper":"AqfaB"};